export default "__VITE_ASSET__CZQAVH_c__"